<template>
  <v-bottom-navigation
    color="white"
    horizontal
    app
    background-color="primary"
  >
    <v-btn 
      v-clipboard:copy="url"             
      v-clipboard:success="onCopy"
      v-clipboard:error="onError"
    >
      <span>Yelp Review Link</span>
      <v-icon>mdi-content-paste</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
    export default {
        data () {
            return {
              url: 'https://www.yelp.com/writeareview/biz/Jdhy6V1wGmbgMTX1Dr3SdA?return_url=%2Fbiz%2FJdhy6V1wGmbgMTX1Dr3SdA&source=biz_details_war_button'
            }
        },
        methods: {
            onCopy: function () {
                this.$store.commit('SET_SNACKTYPE', 'green')
                this.$store.commit('SET_SNACK', 'Successfully copied!')
            },
            onError: function () {
                this.$store.commit('SET_SNACKTYPE', 'red')
                this.$store.commit('SET_SNACK', 'Failed to copy! Please try again.')
            }
        }
    }
</script>

<style lang="sass">
.v-bottom-navigation 
  button 
      span
          color: #fff

  .v-btn
    >.v-btn__content
      color: #fff
      
      .v-icon
        color: #fff
</style>